<app-import-nav />

<h5 class="mt-3">Import Pharmacies</h5>

@if (hasError) {
  <div class="alert alert-danger">
    There was a problem uploading the file.
    <ul class="mt-2">
      @for (error of errors; track error) {
        <li>{{ error }}</li>
      }
    </ul>
  </div>
}

<app-icc-import-upload
  (uploadComplete)="onUploadComplete($event)"
  (uploadStart)="onUploadStart()"
  />

<div class="mt-3 border p-3 rounded">
  <strong>File Requirements</strong>
  <ol class="mx-3 ps-2">
    <li class="py-2">
      Possible fields
      <ul class="ps-2">
        <li><code>pharmacy_id</code> <span>(required)</span></li>
        <li><code>medicaid_excluded</code> <span>(required, boolean, Y or N)</span></li>
        <li><code>type</code> <span>(required, O or C)</span></li>
      </ul>
    </li>
    <li class="py-2">
      Example file
      <div>
        <small><strong>NOTE:</strong> Extra columns will be ignored and column headers are case insensitive.</small>
      </div>
      <div class="bg-light p-2 border w-100">
        <small>
          <strong>
            <code class="csv-header">
              pharmacy_id,medicaid_excluded,type
            </code>
          </strong>
          <br />
          <code>1214336,N,O</code><br />
          <code>1214337,Y,C</code><br />
        </small>
      </div>
    </li>
    <li class="py-2"><code>.csv</code> only</li>
  </ol>
</div>
